import { MessageSquare, MonitorSmartphone, Usb } from "lucide-react";
import { SectionHead, FadeUp } from "@/components/Reveal";
import { COMPAT } from "@/lib/content";

const ICONS = { message: MessageSquare, monitor: MonitorSmartphone, usb: Usb };

export default function Compatibility() {
  return (
    <section className="relative py-24 sm:py-32 border-t border-white/5" data-testid="compatibility-section">
      <div className="max-w-7xl mx-auto px-5 sm:px-8">
        <SectionHead eyebrow="Universally compatible" title="One tool. Every platform you work on." />

        <div className="mt-16 grid grid-cols-1 md:grid-cols-3 gap-6">
          {COMPAT.map((group, gi) => {
            const Icon = ICONS[group.icon];
            return (
              <FadeUp key={group.title} delay={gi * 0.1} className="h-full">
                <div data-testid={`compat-group-${gi}`} className="h-full rounded-2xl border border-white/5 bg-surface p-8">
                  <div className="flex items-center gap-3.5">
                    <div className="w-10 h-10 rounded-xl border border-neon/25 bg-neon/10 flex items-center justify-center">
                      <Icon size={17} className="text-neon" />
                    </div>
                    <h3 className="font-display font-bold text-lg text-white tracking-tight">{group.title}</h3>
                  </div>
                  <ul className="mt-7 space-y-3.5">
                    {group.items.map((item) => (
                      <li key={item} className="flex items-center gap-3 text-mist text-[15px]">
                        <span className="w-1.5 h-1.5 rounded-full bg-neon/70 shrink-0" />
                        {item}
                      </li>
                    ))}
                  </ul>
                </div>
              </FadeUp>
            );
          })}
        </div>
      </div>
    </section>
  );
}
